import React from "react";

const Home = () => {
  return (
    <React.StrictMode>
      <div className="main-page-content">
        <div id="home">
          <div id="particles-js"></div>
          <div className="home-content-main">
            <div className="table-cell">
              <div className="container">
                <div className="row home-row">
                  <div className="col-md-12 col-sm-12">
                    <div className="home-text wow fadeIn text-center">
                      <h1 className="cd-headline clip is-full-width">
                        <span
                          className="cd-words-wrapper"
                          style={{ width: "266px", overflow: "hidden" }}
                        >
                          <b className="is-hidden">CA Harsha</b>
                          <b className="is-hidden ca">Chartered Accountant</b>
                          <b className="is-visible">ARV Tax Corp</b>
                        </span>
                      </h1>
                      <div className="about-social-icon text-center">
                        <ul className="about-social">
                          <li className="wow fadeIn" data-wow-delay=".2s">
                            <a
                              href="https://wa.me/+917995162535"
                              target="newtab"
                            >
                              <i
                                className="fa fa-whatsapp"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                          <li className="wow fadeIn" data-wow-delay=".6s">
                            <a
                              href="https://instagram.com/arv_taxcorp?igshid=MzNlNGNkZWQ4Mg=="
                              target="newtab"
                            >
                              <i
                                className="fa fa-instagram"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                          <li className="wow fadeIn" data-wow-delay=".8s">
                            <a
                              href="https://twitter.com/ArvTax?t=X__CRmGbJSScqUWIMQMjRw&s=09"
                              target="newtab"
                            >
                              <i
                                className="fa fa-twitter"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                          <li className="wow fadeIn" data-wow-delay="1s">
                            <a
                              href="https://youtube.com/@arvtaxcorpindla6544"
                              target="newtab"
                            >
                              <i
                                className="fa fa-youtube"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                          <li className="wow fadeIn" data-wow-delay=".4s">
                            <a
                              href="https://www.linkedin.com/in/ca-harshareddy"
                              target="newtab"
                            >
                              <i
                                className="fa fa-linkedin"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="parallax" data-velocity="-.1"></div>
          <div className="parallax" data-velocity="-.5" data-fit="525"></div>
        </div>

        {/* <!-- ================================ ABOUT =============================== --> */}

        <div id="about">
          <div className="about-content">
            <div className="me-grid">
              <div className="container">
                <div className="row">
                  <div className="col-md-4 col-sm-6 col-xs-12 about-col">
                    <div className="about-image" height="100" width="100">
                      <img
                        src="assets/img/CA-logo-min.webp"
                        alt="CA- Harsha Reddy"
                        className="about-img wow fadeIn"
                      />
                    </div>
                  </div>
                  <div className="col-md-8 col-sm-6 col-xs-12 about-col">
                    <div className="about-details wow fadeIn">
                      <div className="main-title left-title text-left wow fadeIn">
                        <h3>Hello!! This is CA- Harsha Reddy</h3>
                        <div className="underline1 no-margin"></div>
                        <div className="underline2 no-margin"></div>
                      </div>
                      <p className="wow fadeIn">
                        I am a Chartered Accountant having 4 years of experience
                        in CA practice. Having expertise knowledge in the fileds
                        of GST, Income tax and Audit & Assurance and working
                        experience of Big4 audit firms. I am having DISA
                        Qualification for conducting System Audits.{" "}
                        <a className="underline2" href="#contact">
                          {" "}
                          here.
                        </a>{" "}
                        I'm passionate in providing smart and smooth solutions
                        for various Business complexites and love what I do.
                        <br />
                        <br />
                        We believe in continuous and simultaneous growth along
                        with our clients and friends.
                      </p>
                      {/* <a
                        className="about-link-1"
                        href="assets/cv/ca- harshareddy-profile.pdf"
                        target="_blank"
                      >
                        See Resume
                      </a>
                      <a className="about-link-2" href="#contact">
                        Hire Me
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="love-grid text-center">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-title text-center wow fadeIn">
                      <h3>What I do</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        At present time we are working on a multi- role, as a
                        Chartered Accountant's we provide a wide range of
                        services related to Accounting, Taxation, Auditing,
                        Financial management and Business advisory.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row love-row wow fadeIn">
                  <div className="col-md-3 col-sm-6">
                    <div className="love-details" data-wow-delay=".1s">
                      <i
                        className="fa fa-pencil-square-o love-icon"
                        aria-hidden="true"
                      ></i>
                      <h3>GST & Income Tax</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        We provide smart and smooth solutions for Tax
                        compliances & GST filings, Handling Notices &
                        Assessments Tax Audits, Filing Corporate ITR's
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <div className="love-details" data-wow-delay=".3s">
                      <i
                        className="fa fa-file-image-o love-icon"
                        aria-hidden="true"
                      ></i>
                      <h3>Auditing & Assurance</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        We provide Statutory Audits, Internal Audits, Financial
                        Statement Audits, Due Diligence Audits and Systems and
                        IT Audits
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <div className="love-details" data-wow-delay=".2s">
                      <i
                        className="fa fa-globe love-icon"
                        aria-hidden="true"
                      ></i>
                      <h3>Financial Reporting and Analysis</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        Assist in Preparation of Financial Statements, Financial
                        Forecasting and Budgeting,and Customized Reporting
                        Solutions
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <div className="love-details" data-wow-delay=".1s">
                      <i
                        className="fa fa-pencil-square-o love-icon"
                        aria-hidden="true"
                      ></i>
                      <h3>Management Accounting</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        We provide Cost Accounting, Profitability Analysis,
                        Strategic Cost Management and Management Reporting
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row love-row wow fadeIn">
                  <div className="col-md-3 col-sm-6">
                    <div className="love-details" data-wow-delay=".4s">
                      <i className="fa fa-cog love-icon" aria-hidden="true"></i>
                      <h3>Business Advisory and Consultancy</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        We provide Business Planning and Strategy, Business
                        Valuation and Compliance and Regulatory Advisory
                        services
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <div className="love-details" data-wow-delay=".3s">
                      <i
                        className="fa fa-file-image-o love-icon"
                        aria-hidden="true"
                      ></i>
                      <h3>Financial Planning and Wealth Management</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        We offer Investment Planning, Tax Planning and Risk
                        Management and Insurance Planning services
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <div className="love-details" data-wow-delay=".2s">
                      <i
                        className="fa fa-globe love-icon"
                        aria-hidden="true"
                      ></i>
                      <h3>Regulatory Compliance</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        We provide Financial Reporting Compliance,Company Law
                        Compliance, Internal Control Evaluation and Regulatory
                        Updates and Advisory
                      </p>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-6">
                    <div className="love-details" data-wow-delay=".4s">
                      <i className="fa fa-cog love-icon" aria-hidden="true"></i>
                      <h3>Accounting and Bookkeeping</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        We provide Payroll Processing, Financial Data Analysis,
                        GST and Income tax filings and Financial Records Review
                        and Audit Support
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="about-back"></div>

            {/* <div className="work-counter text-center">
              <div className="counter">
                <div className="container">
                  <div className="row wow fadeIn">
                    <div className="col-md-3 col-sm-6">
                      <div className="work-statistics">
                        <i
                          className="fa fa-pencil-square-o stat-icon"
                          aria-hidden="true"
                        ></i>
                        <h3 className="Count">0021</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>Web Design Completed</p>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                      <div className="work-statistics">
                        <i
                          className="fa fa-crop stat-icon"
                          aria-hidden="true"
                        ></i>
                        <h3 className="Count">0040</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>UI/UX Design Done</p>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                      <div className="work-statistics">
                        <i
                          className="fa fa-bolt stat-icon"
                          aria-hidden="true"
                        ></i>
                        <h3 className="Count">0015</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>Website Created</p>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                      <div className="work-statistics">
                        <i
                          className="fa fa-coffee stat-icon"
                          aria-hidden="true"
                        ></i>
                        <h3 className="Count">0085</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>Cups Coffee Taken</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        {/* <!-- ================================ Skill =============================== --> */}

        {/* <div id="skill">
          <div className="skill-main">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="main-title text-center wow fadeIn">
                    <h3>My Skill</h3>
                    <div className="underline1"></div>
                    <div className="underline2"></div>
                    <p>
                      I value simple content structure, clean design patterns,
                      and thoughtful interactions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row love-row wow fadeIn">
                <div className="col-md-6">
                  <div className="skill-details text-left">
                    <p>
                      UI/UX involves planning and iterating a site's structure
                      and layout. Once the proper information architecture is in
                      place, I design the visual layer to create a beautiful
                      user experience. Front End Development is building out the
                      visual components of a website. Using HTML, CSS, and
                      Javascript, I build fast, interactive websites. This also
                      may include a CMS, apis, or other integrations. The work
                      that I am most interested in is 0-1 work (helping you get
                      your idea into the world).
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="skill-details">
                    <div className="content">
                      <div className="col">
                        <ul id="skill-main">
                          <li>
                            <h3>HTML / CSS - 97%</h3>
                          </li>
                          <li>
                            <h3>UI / UX - 92%</h3>
                          </li>
                          <li>
                            <h3>React JS - 30%</h3>
                          </li>
                          <li>
                            <h3>PHP (Laravel) - 93%</h3>
                          </li>
                          <li>
                            <h3>MySQL - 95%</h3>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* <!-- ============================================== SERVICE ===================================================== --> */}

        <div id="service">
          <div className="service-content">
            <div className="service-grid text-center">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-title text-center wow fadeIn">
                      <h3>Service List</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        We provide a wide range of services related to
                        accounting, taxation, auditing, financial management
                        business advisory.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row love-row wow fadeIn">
                  <div className="col-md-4 col-sm-6">
                    <div className="service-details" data-wow-delay=".1s">
                      <div className="service-head">
                        <img src="assets/img/gstn.jpeg" alt="GST compliances" />
                      </div>
                      <div className="service-bottom">
                        <i
                          className="fa fa-edit service-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>GST compliances</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>
                          GST Registration, Returns, Audit and Assessment,
                          Refunds and handling GST Notices and Assessments
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <div className="service-details" data-wow-delay=".1s">
                      <div className="service-head">
                        <img src="assets/img/itax-c.jpeg" alt="e-commarce" />
                      </div>
                      <div className="service-bottom">
                        <i
                          className="fa fa-cart-plus exp-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Income Tax compliances</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>
                          Tax Planning and Advisory, Income Tax Return
                          Preparation and Filing, Tax Compliance and Reporting,
                          Tax Audits and Assessments, Taxation for Individuals,
                          Taxation for Businesses, International Taxation, Tax
                          Dispute Resolution and Tax Withholding and Compliance
                          services.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <div className="service-details" data-wow-delay=".1s">
                      <div className="service-head">
                        <img src="assets/img/audit-a.jpeg" alt="analytics" />
                      </div>
                      <div className="service-bottom">
                        <i
                          className="fa fa-tachometer service-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Audit and Assurance</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>
                          Financial Statement Audit, Internal Audit Services,
                          Review Engagements, Assurance Consulting and Quality
                          Control Reviews.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-6">
                    <div className="service-details" data-wow-delay=".1s">
                      <div className="service-bottom">
                        {/* <i
                          className="fa fa-desktop exp-icon"
                          aria-hidden="true"
                        ></i> */}
                        <h3>Other services</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                        <p>
                          Cash Flow Management, Funding and Financing
                          Assistance, Monthly Statutory compliances, Accounting
                          and Bookkeeping, Income tax return (ITR) filings,
                          Projections, Financial Due Diligence, Merger,
                          Acquisition, Regulatory Filings and Documentation and
                          Accounts Payable and Receivable Management
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="testimonial">
              <div className="testimonial-content">
                <div className="testimonial-grid">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="main-title text-center wow fadeIn">
                          <h3>Testimonials</h3>
                          <div className="underline1"></div>
                          <div className="underline2"></div>
                          <p>
                            People I've worked with have said some nice things
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-details">
                    <section id="carousel">
                      <div className="container">
                        <div className="row">
                          <div className="col-md-8 col-md-offset-2">
                            <div className="quote">
                              <i className="fa fa-quote-left fa-4x"></i>
                            </div>
                            <div
                              className="carousel slide"
                              id="fade-quote-carousel"
                              data-ride="carousel"
                              data-interval="3000"
                            >
                              <ol className="carousel-indicators">
                                <li
                                  data-target="#fade-quote-carousel"
                                  data-slide-to="0"
                                  className="active"
                                ></li>
                                <li
                                  data-target="#fade-quote-carousel"
                                  data-slide-to="1"
                                ></li>
                                <li
                                  data-target="#fade-quote-carousel"
                                  data-slide-to="2"
                                ></li>
                              </ol>
                              <div className="carousel-inner">
                                <div className="active item">
                                  <blockquote>
                                    <p>
                                      “Arv Tax Corp is One of the best Chartered
                                      Accountant in Hyderabad. Gives first and
                                      top priority to its client, Experts in
                                      Income Tax, Company registration and GST
                                      Consultant... Costing is also very
                                      reasonable. I must recommend their
                                      services to everyone..”
                                      <br />
                                      <span>Ashok Reddy</span>
                                    </p>
                                  </blockquote>
                                </div>
                                <div className="item">
                                  <blockquote>
                                    <p>
                                      “Immediate response and Good Service/Work
                                      from ARV Tax Corp. Income Tax Returns,
                                      Income Tax Consultancy, Accounting,
                                      Auditing, Taxation, Company Works,
                                      Management Accounting, The Chartered
                                      Accountant for GST Compliances and
                                      liasoning with depaprtment matters..”
                                      <br />
                                      <span>Indla & Associates</span>
                                    </p>
                                  </blockquote>
                                </div>
                                <div className="item">
                                  <blockquote>
                                    <p>
                                      “It's great service experience from ARV
                                      Tax corp. I hope if any one once visit
                                      they don't have a reason to shift to
                                      anyone for financial services. Regarding
                                      Financial services i can assure that you
                                      name a (it) service, That have it......”
                                      <br />
                                      <span>Ashok kumar Venna</span>
                                    </p>
                                  </blockquote>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- ================================ BLOG ========================== --> */}

        <div id="blog">
          <div className="blog-content">
            <div className="blog-grid">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className="main-title text-center wow fadeIn">
                      <h3>My Blog</h3>
                      <div className="underline1"></div>
                      <div className="underline2"></div>
                      <p>
                        The Blog, Which has thoughts on life, work and
                        everything in between.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="blog-details wow fadeIn text-left">
                <div className="container">
                  <div className="row">
                    <div className="col-md-6 col-sm-6">
                      <div className="blog-main">
                        <a
                          href="https://www.business-standard.com/finance/news/itc-can-t-be-denied-under-gst-even-when-post-supply-discounts-received-aar-123062800236_1.html"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="assets/img/GST-ITC-blog.jpg"
                            alt="React hooks were introduced in version 16.8"
                            className="blog-img"
                          />
                        </a>
                        <div className="blog-head">
                          <a
                            href="https://www.business-standard.com/finance/news/itc-can-t-be-denied-under-gst-even-when-post-supply-discounts-received-aar-123062800236_1.html"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                          >
                            <h3>
                              <strong>
                                ITC can’t be denied under GST even when
                                post-supply discounts received: AAR
                              </strong>
                            </h3>
                          </a>
                        </div>
                        <div className="blog-bottom">
                          <p>
                            Input tax credit would not be denied under the goods
                            and services tax (GST) system even when a company
                            receives post-supply discounts, provided the entire
                            tax liability is paid, the authority for advance
                            rulings (AAR) in Andhra Pradesh has ruled. Vedmutha
                            Electricals, a distributor of electronic goods,
                            sought advance ruling whether it can claim a full
                            credit on the original invoice amount even if the
                            discount is not reflected in the invoice.
                          </p>
                          <a
                            href="/blog-post"
                            rel="noopener noreferrer"
                            className="about-link-2"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="blog-main">
                        <a href="/#service">
                          <img
                            src="assets/img/our-services.jpg"
                            alt="The importance of UI/UX"
                            className="blog-img"
                          />
                        </a>
                        <div className="blog-head">
                          <h3>
                            <strong>Our Services</strong>
                          </h3>
                        </div>
                        <div className="blog-bottom">
                          <p>
                            ARV Tax Corp LLP is a boutique Indirect Tax firm
                            having its offices at Hyderabad and Banglore
                            specializing in GST, Central Excise, Custom, Service
                            Tax, VAT, DGFT, Foreign Trade Policy, SEZ, EOU,
                            Export – Import Laws, Free Trade Policy, etc. It is
                            a professionally managed firm having a team of
                            experienced and distinguished Chartered Accountants,
                            Company Secretary, Lawyers, Corporate Financial
                            Advisors and Tax consultants to provide various
                            services like litigation and representation,
                            transaction advisory, diagnostic reviews/ health
                            checks, audit defense & protection, retainership &
                            compliance, configuration of tax efficient business
                            model etc...
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- ================================ CONTACT ========================== --> */}
        <div id="contact">
          <div className="contact-content">
            <div className="text-grid">
              <div className="text-grid-main">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <div className="main-title text-center wow fadeIn">
                        <h3>Contact us</h3>
                        <div className="underline1"></div>
                        <div className="underline2"></div>
                       {/* <form name="contact" method="POST" data-netlify="true">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="name">Name:</label>
                              <input
                                type="text"
                                id="name"
                                name="name"
                                required
                              />
                            </div>
                            <div className="col-md-6">
                              <label htmlFor="email">Email:</label>
                              <input
                                type="email"
                                id="email"
                                name="email"
                                required
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <label htmlFor="message">Message:</label>
                              <textarea
                                id="message"
                                name="message"
                                required
                              ></textarea>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <button type="submit">Submit</button>
                            </div>
                          </div>
                        </form> */}
                         <p>
                          We always open to advice clients on new business opportunities and continuous updates on regulatory compliances.
                        </p> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-grid">
              <div className="contact-form-details wow fadeIn">
                <div className="container">
                  <div className="row contact-info-row text-center wow fadeIn">
                    <div className="col-md-4 col-sm-6 contact-colamn">
                      <div className="contact-col-info" data-wow-delay=".4s">
                        <a
                          href="mailto:contact.arvmrkp@gmail.com"
                          style={{
                            color: "black",
                            textDecoration: "none",
                            fontSize: "17px",
                          }}
                        >
                          {" "}
                          <i
                            className="fa fa-envelope contact-icon"
                            aria-hidden="true"
                          ></i>
                        </a>
                        <h3>Email</h3>
                        <a
                          href="mailto:contact.arvmrkp@gmail.com"
                          style={{
                            color: "black",
                            textDecoration: "none",
                            fontSize: "17px",
                          }}
                        >
                          E-mail us: arvmrkp@gmail.com
                        </a>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6 contact-colamn">
                      <div className="contact-col-info" data-wow-delay=".2s">
                        <a href="https://goo.gl/maps/dwZsw2RvUwXgoT8F8">
                          {" "}
                          <i
                            className="fa fa-map-marker contact-icon"
                            aria-hidden="true"
                          ></i>
                        </a>
                        <h3>Address</h3>
                        <p>
                          Plot No. 77, 104, Jayanagar Colony, Kukatpally,
                          Hyderabad, Telangana, 500072
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6 contact-colamn">
                      <div className="contact-col-info" data-wow-delay=".6s">
                        <a
                          href="tel:7995162535"
                          style={{
                            color: "black",
                            textDecoration: "none",
                            fontSize: "17px",
                          }}
                        >
                          {" "}
                          <i
                            className="fa fa-mobile contact-icon"
                            aria-hidden="true"
                          ></i>
                        </a>
                        <h3>Phone</h3>
                        <a
                          href="tel:7995162535"
                          style={{
                            color: "black",
                            textDecoration: "none",
                            fontSize: "17px",
                          }}
                        >
                          +91 7995162535
                        </a>
                      </div>
                    </div>
                    {/* <div className="col-md-3 col-sm-6 contact-colamn">
                      <div className="contact-col-info" data-wow-delay=".6s">
                        <i
                          className="fa fa-television contact-icon"
                          aria-hidden="true"
                        ></i>
                        <h3>Portfolio</h3>
                        <p>https://ca-harshareddy.github.io/</p>
                      </div>
                    </div> */}
                  </div>
                  {/* <div className="row">
                    <div className="col-md-4 col-xs-12">
                    <InterestCalculator />
                    </div>
                    <div className="col-md-8 col-xs-12">
                      <TaxableIncomeCalculator />
                    <RubiksCube />
                    </div>
                    </div> */}
                </div>
                <div class="container-fluid map-col">
                  <div class="col-md-12 col-sm-12 map-col">
                    <div class="google-maps">
                      <div class="map-wrap">
                        <iframe
                          title="google-maps"
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.1754920025865!2d78.40237721487792!3d17.499134188011656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9145b7d230b9%3A0x953948cedfd4c58a!2sArv%20Tax%20Corp!5e0!3m2!1sen!2sin!4v1688047029491!5m2!1sen!2sin"
                          // <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.1754920025865!2d78.40237721487792!3d17.499134188011656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9145b7d230b9%3A0x953948cedfd4c58a!2sArv%20Tax%20Corp!5e0!3m2!1sen!2sin!4v1688047029491!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                          // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d471220.5630603985!2d88.0495328251319!3d22.675752087592436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f882db4908f667%3A0x43e330e68f6c2cbc!2sKolkata%2C%20West%20Bengal!5e0!3m2!1sen!2sin!4v1653845709428!5m2!1sen!2sin"
                          width="100%"
                          height="450"
                          style={{ border: "0" }}
                          allowfullscreen=""
                          loading="lazy"
                          referrerpolicy="no-referrer-when-downgrade"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.StrictMode>
  );
};

export default Home;
